<template>
    <div class="extra-all">
        <b-container>
            <b-form @submit="save" novalidate class="mb-5">
                <h1 v-html="extra.name"></h1>

                <div class="card p-4">
                    <h4>Optional Extra</h4>

                    <b-form-group>
                        <b-row class="mb-4">
                            <b-col cols="6">
                                <label for="name">Internal Name</label>
                                <b-form-input v-model="extra.name" id="name"></b-form-input>
                            </b-col>

                            <b-col cols="6">
                                <label for="name">Consumer Name</label>
                                <b-form-input v-model="extra.consumerName" id="consumer-name"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-4">
                            <b-col cols="6">
                                <label for="cost-price">Cost Price</label>
                                <b-input-group>
                                    <b-input-group-addon>&pound;</b-input-group-addon>
                                    <b-form-input v-model="extra.costPrice" id="cost-price" type="number"></b-form-input>
                                </b-input-group>
                            </b-col>

                            <b-col cols="6">
                                <label for="ssp">SSP</label>
                                <b-input-group>
                                    <b-input-group-addon>&pound;</b-input-group-addon>
                                    <b-form-input v-model="extra.ssp" id="ssp" type="number"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>
                    </b-form-group>

                    <h4 class="pt-4">Website Content</h4>

                    <b-form-group>
                      <b-row>
                        <b-col cols="12">
                          <label for="description">Description (visible on website)</label>
                          <b-textarea v-model="extra.description" id="description" rows="4"></b-textarea>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="12">
                          <label for="images" class="mt-4">Images (visible on website)</label>
                          <product-images v-bind:product="extra" type="photo" editable="true" default-message="Upload your photos here (min. 400x400)" min-width="400" min-height="400" max-images="6"></product-images>
                        </b-col>
                      </b-row>
                    </b-form-group>

                    <h4 class="pt-4">Availability</h4>

                    <b-form-group>
                        <label>
                            <input v-model="extra.availableTo" name="availableTo" value="*" type="radio" /> All
                        </label>

                        <br />

                        <label>
                            <input v-model="extra.availableTo" name="availableTo" value="gbc" type="radio" /> GBC Only
                        </label>

                        <br />

                        <label>
                          <input v-model="extra.availableTo" name="availableTo" value="direct" type="radio" /> Direct UK Orders Only
                        </label>

                        <br />

                        <label>
                          <input v-model="extra.availableTo" name="availableTo" value="gbcDirect" type="radio" /> GBC & Direct UK Orders Only
                        </label>
                    </b-form-group>

                    <h4 class="pt-4">Families</h4>
                    <ul class="checkboxes">
                        <li v-for="option in familyOptions">
                            <label>
                                <input type="checkbox" name="families" v-model="selectedFamilies" :value="option.value"> {{ option.text }}
                            </label>
                        </li>
                    </ul>

                    <h4 class="pt-4">Colours</h4>
                    <ul class="checkboxes">
                        <li v-for="option in colourOptions">
                            <label>
                                <input type="checkbox" name="families" v-model="selectedColours" :value="option.value"> {{ option.text }}
                            </label>
                        </li>
                    </ul>

                    <h4 class="pt-4">Variation</h4>
                    <ul class="checkboxes">
                        <li v-for="option in variationOptions">
                            <label>
                                <input type="checkbox" name="variations" v-model="selectedVariations" :value="option.value"> {{ option.text }}
                            </label>
                        </li>
                    </ul>

                    <h4 class="pt-4">Style</h4>
                    <p class="text-center">Only applies to {{ styleAppliesTo.join(', ') }}</p>
                    <ul class="checkboxes">
                        <li v-for="option in ['S1', 'S2', 'S3']">
                            <label>
                                <input type="checkbox" name="styles" v-model="selectedStyles" :value="option"> {{ option }}
                            </label>
                        </li>
                    </ul>

                    <h4 class="pt-4 pb-2">Products</h4>

                    <b-row class="mb-2">
                        <b-col cols="6" class="text-right">Filter this table:</b-col>
                        <b-col cols="6">
                            <b-row>
                                <b-col cols="3">
                                    <b-form-input v-model="filterFamily" placeholder="Family"></b-form-input>
                                </b-col>
                                <b-col cols="3">
                                    <b-form-input v-model="filterColour" placeholder="Colour"></b-form-input>
                                </b-col>
                                <b-col cols="3">
                                    <b-form-input v-model="filterVariation" placeholder="Variation"></b-form-input>
                                </b-col>
                                <b-col cols="3">
                                    <b-form-input v-model="filterStyle" placeholder="Style"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                    <div style="max-height:800px;overflow-y:scroll">
                        <b-table striped :items="products" :filter="filterFunction" :fields="['family', 'colour', 'variation', 'style', 'price']" v-if="products.length && (filterFamily || filterColour || filterVariation || filterStyle)">
                            <template slot="price" scope="row">
                                <b-input-group>
                                    <b-input-group-addon>&pound;</b-input-group-addon>
                                    <b-form-input v-model="overriddenPrices[row.item.key]" id="cost" type="number"></b-form-input>
                                </b-input-group>
                            </template>

                            <template slot="family" scope="row">
                                {{ row.item.family.name }}
                            </template>

                            <template slot="colour" scope="row">
                                {{ row.item.colour.name }}
                            </template>

                            <template slot="style" scope="row">
                                {{ row.item.style }}
                            </template>

                            <template slot="variation" scope="row">
                                {{ row.item.variation.name }}
                            </template>
                        </b-table>
                    </div>

                    <b-alert :show="!products.length" variant="warning">No products have been selected to receive this extra yet.</b-alert>
                </div>

                <b-button type="submit" size="lg" class="ml-auto mr-auto mt-4 d-block" variant="success">Save</b-button>
            </b-form>
        </b-container>

        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
</template>

<script>
  import Simplert from 'vue2-simplert'
  import ProductImages from './ProductImages'

  export default {
    name: 'extra',
    props: ['fb'],
    components: {
      Simplert,
      ProductImages
    },
    firebase () {
      return {
        _extra: {
          source: this.fb.database().ref('extras/' + this.$route.params.id),
          asObject: true,
          readyCallback () {
            this.extra = this._extra
            if (!this.extra.families) {
              this.extra.families = []
            }
            if (!this.extra.colours) {
              this.extra.colours = []
            }
            if (!this.extra.variations) {
              this.extra.variations = []
            }
            if (!this.extra.overriddenPrices) {
              this.extra.overriddenPrices = {}
            }
            if (!this.extra.consumerName) {
              this.extra.consumerName = this.extra.name
            }
            this.selectedFamilies = this.extra.families
            this.selectedColours = this.extra.colours
            this.selectedVariations = this.extra.variations
            this.overriddenPrices = this.extra.overriddenPrices
            this.selectedStyles = this.extra.selectedStyles
          }
        },
        families: this.fb.database().ref('families').orderByChild('name'),
        colours: this.fb.database().ref('colours').orderByChild('name')
      }
    },
    data () {
      return {
        extra: {},
        selectedFamilies: [],
        selectedColours: [],
        selectedVariations: [],
        selectedStyles: [],
        overriddenPrices: {},
        styleAppliesTo: ['Manhattan', 'Greenwich', 'Broadway'],
        filterFamily: '',
        filterColour: '',
        filterVariation: '',
        filterStyle: ''
      }
    },
    computed: {
      familyOptions () {
        let options = []
        for (let i = 0; i < this.families.length; i++) {
          let value = this.families[i]
          value['key'] = value['.key']
          delete value['.key']
          options.push({
            text: this.families[i].name,
            value: this.families[i]
          })
        }
        return options
      },
      colourOptions () {
        let options = []
        for (let i = 0; i < this.colours.length; i++) {
          let value = this.colours[i]
          value['key'] = value['.key']
          delete value['.key']
          options.push({
            text: this.colours[i].name,
            value: this.colours[i]
          })
        }
        return options
      },
      variationOptions () {
        let variations = [
          'Default',
          1000,
          1100,
          1200,
          1300,
          1400,
          1500,
          1600,
          1700,
          1800,
          1900,
          2000,
          2100,
          2200,
          2400,
          2500,
          2800,
          3100,
          3200,
          3400,
          4000,
          4600,
          5200,
          5650]
        let variationOptions = []
        for (let i = 0; i < variations.length; i++) {
          variationOptions.push({
            text: '' + variations[i],
            value: {
              key: variations[i],
              name: '' + variations[i]
            }
          })
        }
        return variationOptions
      },
      products () {
        let products = []
        let family
        let colour
        let variation
        this.selectedStyles = ['S1', 'S2', 'S3']
        for (let i = 0; i < this.selectedFamilies.length; i++) {
          family = this.selectedFamilies[i]
          for (let j = 0; j < this.selectedColours.length; j++) {
            colour = this.selectedColours[j]
            for (let k = 0; k < this.selectedVariations.length; k++) {
              variation = this.selectedVariations[k]
              let key = family['key'] + colour['key'] + variation['key']
              let style = ''
              if (this.selectedStyles && this.styleAppliesTo.indexOf(family['name']) !== -1) {
                for (let s = 0; s < this.selectedStyles.length; s++) {
                  style = this.selectedStyles[s]
                  products.push({
                    family: family,
                    colour: colour,
                    variation: variation,
                    style: style,
                    key: key + style,
                    price: this.getOverriddenPrice(family, colour, variation, style)
                  })
                }
              } else {
                products.push({
                  family: family,
                  colour: colour,
                  variation: variation,
                  style: style,
                  key: key,
                  price: this.getOverriddenPrice(family, colour, variation, style)
                })
              }
              if (!this.overriddenPrices.hasOwnProperty(key)) {
                this.overriddenPrices[key] = this.extra.ssp
              }
            }
          }
        }
        return products
      }
    },
    methods: {
      filterFunction (product) {
        let productFamily = product.family.name
        let productColour = product.colour.name
        let productVariation = product.variation.name
        let productStyle = product.style
        if (this.filterFamily) {
          if (!productFamily.startsWith(this.filterFamily)) {
            return false
          }
        }
        if (this.filterColour) {
          if (!productColour.startsWith(this.filterColour)) {
            return false
          }
        }
        if (this.filterVariation) {
          if (!productVariation.startsWith(this.filterVariation)) {
            return false
          }
        }
        if (this.filterStyle) {
          if (!productStyle.startsWith(this.filterStyle)) {
            return false
          }
        }
        return true
      },
      save (e) {
        e.preventDefault()
        if (!this.extra.name) {
          this.$refs.simplert.openSimplert({
            title: 'Error',
            message: 'Please enter the optional extra name',
            type: 'error'
          })
          return
        }
        if (!this.extra.ssp) {
          this.$refs.simplert.openSimplert({
            title: 'Error',
            message: 'Please enter the SSP',
            type: 'error'
          })
          return
        }
        if (!this.extra.costPrice) {
          this.$refs.simplert.openSimplert({
            title: 'Error',
            message: 'Please enter the cost price',
            type: 'error'
          })
          return
        }
        if (!this.products.length) {
          this.$refs.simplert.openSimplert({
            title: 'Error',
            message: 'Please select some products, colours and variations',
            type: 'error'
          })
          return
        }
        // push the info into the object that we need
        this.extra.families = this.selectedFamilies
        this.extra.colours = this.selectedColours
        this.extra.variations = this.selectedVariations
        this.extra.overriddenPrices = this.overriddenPrices
        this.extra.selectedStyles = this.selectedStyles
        for (let i = 0; i < this.extra.families.length; i++) {
          if (this.extra.families[i].hasOwnProperty('.key')) {
            delete this.extra.families[i]['.key']
          }
        }
        for (let i = 0; i < this.extra.colours.length; i++) {
          if (this.extra.colours[i].hasOwnProperty('.key')) {
            delete this.extra.colours[i]['.key']
          }
        }
        this.extra.published = true
        delete this.extra['.key']
        this.$firebaseRefs._extra.set(this.extra).then(() => {
          this.$refs.simplert.openSimplert({
            title: 'Saved',
            type: 'info',
            message: 'Saved'
          })
        })
      },
      getOverriddenPrice (family, colour, variation, style) {
        let key = family['key'] + colour['key'] + variation['key'] + style
        if (this.overriddenPrices.hasOwnProperty(key)) {
          return this.overriddenPrices[key]
        } else if (style === 'S2' || style === 'S3') {
          // this is to deal with the incorrect keys
          if (style === 'S2') {
            style = 'S1S2'
          } else if (style === 'S3') {
            style = 'S1S2S3'
          }
          return this.getOverriddenPrice(family, colour, variation, style)
        }
        return this.extra.ssp
      }
    }
  }
</script>

<style type="text/scss">
    .checkboxes {
        margin: 0;
        padding: 0;
        column-count: 3;
        list-style: none;

        li {
            margin: 0;
            padding: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Extra.vue